<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods:{
     isPastDue() {
    // 过期时间7天
    var time = 604800000;  //1000*60*60*24*7;
    var storage = window.localStorage;
    if (storage.getItem('timestamp')){
      var oldTimestamp = storage.getItem('timestamp');//以前存的时间戳
      var nowTimestamp = new Date().getTime();//当前时间戳
      // 如果当前时间戳> 前面存的时间戳+过期时间 表示已经过期
      var sumTimestamp = Number(oldTimestamp) + time;
      if (nowTimestamp > sumTimestamp) {
        storage.clear();
      }
    }
  }
  },
  mounted(){
    this.isPastDue()
  }
}
</script>


<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue